export enum OrderStatus {
  CLOSED = 'account.orders.status.closed',
  PROCESSING = 'account.orders.status.processing',
  CANCELED = 'account.orders.status.canceled',
  NEW = 'account.orders.status.new',
  DISPATCHED = 'account.orders.status.dispatched',
  WAITING_FOR_PREPAYMENT = 'account.orders.status.waitingForPrepayment',
}
